import React from 'react';
import { Route, BrowserRouter, Redirect, Switch } from 'react-router-dom';
import Login from './public/Login/Login';
import ForgotPassword from './public/ForgotPassword/ForgotPassword';
import Today from './private/Today/Today';
import AutoBot from './private/AutoBot/AutoBot';
import Alerts from './private/Alerts/Alerts';
import News from './private/News/News';
import Settings from './private/Settings/Settings';
import Dashboard from './private/Dashboard/Dashboard';
import Orders from './private/Orders/Orders';
import Analytics from './private/Analytics/Analytics';
import Symbols from './private/Symbols/Symbols';
import Wallet from './private/Wallet/Wallet';
import Positions from './private/Positions/Positions';
import FuturesTrader from './private/FuturesTrader/FuturesTrader';
import NotFound from './components/NotFound';

function Routes() {

    function PrivateRoute({ children, ...rest }) {
        return (
            <Route {...rest} render={() => {
                return localStorage.getItem("token")
                    ? children
                    : <Redirect to='/' />
            }} />
        )
    }

    return (
        <BrowserRouter>
            <Switch>
                <Route path="/" exact>
                    <Login />
                </Route>
                <Route path="/forgot-password" exact>
                    <ForgotPassword />
                </Route>
                <PrivateRoute path="/settings">
                    <Settings />
                </PrivateRoute>
                <PrivateRoute path="/(forders|orders)/:symbol?">
                    <Orders />
                </PrivateRoute>
                <PrivateRoute path="/dashboard">
                    <Dashboard />
                </PrivateRoute>
                <PrivateRoute path="/today">
                    <Today />
                </PrivateRoute>
                <PrivateRoute path="/autobot">
                    <AutoBot />
                </PrivateRoute>
                <PrivateRoute path="/autopilot">
                    <AutoBot />
                </PrivateRoute>
                <PrivateRoute path="/alerts">
                    <Alerts />
                </PrivateRoute>
                <PrivateRoute path="/news">
                    <News />
                </PrivateRoute>
                <PrivateRoute path="/analytics">
                    <Analytics />
                </PrivateRoute>
                <PrivateRoute path="/symbols">
                    <Symbols />
                </PrivateRoute>
                <PrivateRoute path="/wallet">
                    <Wallet />
                </PrivateRoute>
                <PrivateRoute path="/positions">
                    <Positions />
                </PrivateRoute>
                <PrivateRoute path="/futures-trader">
                    <FuturesTrader />
                </PrivateRoute>
                <Route>
                    <NotFound />
                </Route>
            </Switch>
        </BrowserRouter>
    )
}

export default Routes;
